module.exports = __webpack_public_path__ + "media/fonts/formular-black-webfont-e7fa552d34fd99582de1134d28da15d4.woff2";